import {
    DTOCardFormField,
    FieldInCard,
} from 'app/types/form.types'
import {
    AdditionalFeesStatus,
    RangeType,
} from 'app/enums/label.enums'
import {
    AdditionalFeeValue,
} from '../AdditionalFee.types'

type FeesData = {
    ccy?: string,
    originalStatus?: string,
}
type Params = FeesData & {
    fees: {
        id: number,
    }[],
    exists: boolean,
    originalStatus?: string,
    editingAllowed: boolean,
    editingCommentAllowed: boolean,
    getAllowedValues: (param: Record<string, any>) => Record<string, string>
}

type AdditionalFeesFormFields = keyof AdditionalFeeValue

const additionalFeeComponents = ({
    ccy,
    fees,
    exists,
    originalStatus,
    editingAllowed,
    editingCommentAllowed,
    getAllowedValues,
}: Params) => {
    const feesRow: FieldInCard<AdditionalFeesFormFields> = {
        title: 'Fees',
        className: 'fees',
        fields: [{
            name: 'fees',
            labelKey: 'AdditionalFeesUpdateDto.fees',
            componentName: 'Fees',
            currency: ccy,
            value: fees,
            disabled: editingAllowed,
            showSkyNetSpreadSheet: true,
        }],
    }

    const defaultFields: DTOCardFormField<AdditionalFeesFormFields>[] = [{
        title: 'General',
        className: 'general',
        fields: [
            {
                id: 'column1',
                fields: [{
                    name: 'additionalFeesStatus',
                    labelKey: 'AdditionalFeesUpdateDto.additionalFeesStatus',
                    originalStatus,
                    componentName: 'StatusTransitionSelector',
                    useDropdown: true,
                    allowedValues: getAllowedValues(AdditionalFeesStatus),
                    disabled: true,
                }],
            },
            {
                id: 'column2',
                fields: [
                    {
                        name: 'validFrom',
                        labelKey: 'AdditionalFeesUpdateDto.validFrom',
                        componentName: 'DateSelect',
                        disabled: editingAllowed,
                        required: true,
                    },
                    {
                        name: 'validTo',
                        labelKey: 'AdditionalFeesUpdateDto.validTo',
                        componentName: 'DateSelect',
                        disabled: editingAllowed,
                        required: true,
                    },
                    {
                        name: 'requiresManualBillingReview',
                        componentName: 'Checkbox',
                        labelKey: 'OrderBillingInformationView.requiresManualBillingReview',
                        disabled: editingAllowed,
                    },
                ],
            },
            {
                id: 'column3',
                fields: [
                    {
                        name: 'cancellationFeeTimeline',
                        labelKey: 'AdditionalFeesCreateDto.cancellationFeeTimeline',
                        componentName: 'IntegerInput',
                        disabled: editingAllowed,
                        required: true,
                    },
                    {
                        name: 'cancellationDaysType',
                        labelKey: 'AdditionalFeesCreateDto.cancellationDaysType',
                        componentName: 'EnumSelector',
                        allowedValues: getAllowedValues(RangeType),
                        useDropdown: true,
                        disabled: editingAllowed,
                        required: true,
                    },
                ],
            },
            {
                id: 'column4',
                className: 'commentColumn',
                fields: [{
                    name: 'comment',
                    labelKey: 'AdditionalFeesCreateDto.comment',
                    componentName: 'LongText',
                    disabled: editingCommentAllowed && editingAllowed,
                }],
            },
        ],
    }]

    return exists ? [
        ...defaultFields,
        feesRow,
    ] : defaultFields
}

export default additionalFeeComponents
